<template>
  <div class="view">
    <div class="view_title">
      <div class="view_title_item view_title_item_left">
        <span>皮肤</span>
        <div class="view_title_text_bg"/>
      </div>

      <div class="view_title_item title_right">
        <div class="view_title_item_riht_show">
          <img src="../../assets/images/pifu.png">
        </div>
        <div class="view_title_item_riht_bg">
          <img src="../../assets/images/zitu_bg_icon.png">
        </div>
      </div>
    </div>
    <div class="view_content_bg">
      <div class="view_content_bg_title">详情数据</div>

      <div class="view_content_bg_item"  @click="openValue('皮肤自由基')">
        <div class="view_content_bg_item_title">
          <span>皮肤自由基</span><span>{{ skin1Index }}分</span><span>/100</span><span>{{ skin1 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="skin1" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>

      <div class="view_content_bg_item" @click="openValue('皮肤胶原蛋白')">
        <div class="view_content_bg_item_title">
          <span>皮肤胶原蛋白</span><span>{{ skin2Index }}分</span><span>/100</span><span>{{ skin2 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="skin2" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div class="view_content_bg_item" @click="openValue('皮肤油脂')">
        <div class="view_content_bg_item_title">
          <span>皮肤油脂</span><span>{{ skin3Index }}分</span><span>/100</span><span>{{ skin3 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="skin3" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div class="view_content_bg_item" @click="openValue('皮肤免疫')">
        <div class="view_content_bg_item_title">
          <span>皮肤免疫</span><span>{{ skin4Index }}分</span><span>/100</span><span>{{ skin4 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="skin4" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div class="view_content_bg_item" @click="openValue('皮肤水分')">
        <div class="view_content_bg_item_title">
          <span>皮肤水分</span><span>{{ skin5Index }}分</span><span>/100</span><span>{{ skin5 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="skin5" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div class="view_content_bg_item" @click="openValue('皮肤水分流失量')">
        <div class="view_content_bg_item_title">
          <span>皮肤水分流失量</span><span>{{ skin6Index }}分</span><span>/100</span><span>{{ skin6 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="skin6" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div class="view_content_bg_item"  @click="openValue('皮肤血红丝')">
        <div class="view_content_bg_item_title">
          <span>皮肤血红丝</span><span>{{ skin7Index }}分</span><span>/100</span><span>{{ skin7 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="skin7" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div class="view_content_bg_item" @click="openValue('皮肤弹性')">
        <div class="view_content_bg_item_title">
          <span>皮肤弹性</span><span>{{ skin8Index }}分</span><span>/100</span><span>{{ skin8 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="skin8" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div class="view_content_bg_item" @click="openValue('皮肤黑色素')">
        <div class="view_content_bg_item_title">
          <span>皮肤黑色素</span><span>{{ skin9Index }}分</span><span>/100</span><span>{{ skin9 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="skin9" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>

      <div class="view_content_bg_item" @click="openValue('皮肤角质')">
        <div class="view_content_bg_item_title">
          <span>皮肤角质</span><span>{{ skin10Index }}分</span><span>/100</span><span>{{ skin10 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="skin10" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>

      <div style="height: 28px"/>

    </div>
    <view_bottom></view_bottom>
  </div>
</template>

<script>
import view_bottom from "@/pages/healthy/view_bottom";
import axios from "axios";

export default {
  name: "ReportI",
  components: {view_bottom},
  data() {
    return {
      skin1: "",
      skin2: "",
      skin3: "",
      skin4: "",
      skin5: "",
      skin6: "",
      skin7: "",
      skin8: "",
      skin9: "",
      skin10: "",
      skin1Index: "",
      skin2Index: "",
      skin3Index: "",
      skin4Index: "",
      skin5Index: "",
      skin6Index: "",
      skin7Index: "",
      skin8Index: "",
      skin9Index: "",
      skin10Index: "",

    }
  },
  created() {
    // document.title = '舌诊评估'
    let userId = this.$route.query.userId
    console.log(userId)
    this.getcode(userId)
  },
  methods: {
    getcode(userId) {
      // let url = "https://shezhen.yuanjiwei.cn/api/app/getskin?" + userId
      let url = "https://smxxcx.slyxkj.com/jeecgboot/api/app/getskin?" + userId
      this.br = "<br/>"
      axios.get(url)
          .then((result) => {
            console.log(result)
            this.skin1 = result.data.result.skin1
            this.skin2 = result.data.result.skin2
            this.skin3 = result.data.result.skin3
            this.skin4 = result.data.result.skin4
            this.skin5 = result.data.result.skin5
            this.skin6 = result.data.result.skin6
            this.skin7 = result.data.result.skin7
            this.skin8 = result.data.result.skin8
            this.skin9 = result.data.result.skin9
            this.skin10 = result.data.result.skin10
            this.skin1Index = result.data.result.skin1Index
            this.skin2Index = result.data.result.skin2Index
            this.skin3Index = result.data.result.skin3Index
            this.skin4Index = result.data.result.skin4Index
            this.skin5Index = result.data.result.skin5Index
            this.skin6Index = result.data.result.skin6Index
            this.skin7Index = result.data.result.skin7Index
            this.skin8Index = result.data.result.skin8Index
            this.skin9Index = result.data.result.skin9Index
            this.skin10Index = result.data.result.skin10Index
            this.initBarChart("skin1", this.skin1)
            this.initBarChart("skin2", this.skin2)
            this.initBarChart("skin3", this.skin3)
            this.initBarChart("skin4", this.skin4)
            this.initBarChart("skin5", this.skin5)
            this.initBarChart("skin6", this.skin6)
            this.initBarChart("skin7", this.skin7)
            this.initBarChart("skin8", this.skin8)
            this.initBarChart("skin9", this.skin9)
            this.initBarChart("skin10", this.skin10)

          }).catch(error => {
        this.$router.replace("error")
      });
    },
    initBarChart(view, count) {
      let jiankang = this.$echarts.init(document.getElementById(view))
      let option = {
        grid: {
          left: '0',
          top: '0',
          right: '0',
          bottom: '0',
          containLabel: true,
          width: '100%'
        },
        xAxis: {
          type: 'value',
          splitLine: {show: false},
          axisLabel: {show: false},
          axisTick: {show: false},
          axisLine: {show: false},

        },
        yAxis: {
          type: 'category',
          axisTick: {show: false},
          axisLine: {show: false},
          axisLabel: {
            color: 'black',
            fontSize: 25,
            show: false,
          },
        },
        series: [
          {
            type: 'bar',
            barWidth: 18,
            data: [count],
            label: {
              //position    : 'middle',
              offset: [20, 2],
              color: '#fff',
              fontSize: 30,
            },
            itemStyle: {
              color: this.$echarts.graphic.LinearGradient(
                  1, 0, 0, 0,
                  [
                    {offset: 0, color: '#16CCBD'},                   //柱图渐变色
                    // {offset: 0.5, color: '#44C0C1'},                 //柱图渐变色
                    {offset: 1, color: '#4BEB76'},                   //柱图渐变色
                  ]
              ),
              barBorderRadius: 9,
            },
            zlevel: 1
          },
          {
            name: '进度条背景',
            type: 'bar',
            barGap: '-100%',
            barWidth: 18,
            data: [100],
            color: '#E3ECF2',//柱条颜色
            itemStyle: {
              normal: {
                barBorderRadius: 9,
                borderColor: '#FEFEFE',
              }
            }
          }
        ]
      };
      jiankang.setOption(option);
    },
    openValue(info){
      this.$router.push({path:"/Healthy/Introduce",query:{userId:info,date:new Date().getTime()}})
    }
  }
}
</script>

<style scoped>

.view_content_bg_item {
  background: #F7FAFA;
  border-radius: 32px;
  margin-top: 24px;
  margin-left: 32px;
  margin-right: 32px;
}

.view_content_bg_item_title {
  padding: 32px 32px 16px;
}

.view_content_bg_item_title > span:nth-child(1) {
  font-size: 28px;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  text-align: left;
  vertical-align: top;
}

.view_content_bg_item_title > span:nth-child(2) {
  font-size: 28px;
  font-weight: 400;
  color: rgba(255, 195, 0, 1);
  padding-left: 16px;
  text-align: left;
  vertical-align: top;
}

.view_content_bg_item_title > span:nth-child(3) {
  font-size: 24px;
  font-weight: 400;
  color: rgba(199, 199, 199, 1);
  text-align: center;
  margin-top: 4px;
  padding-left: 6px;
  vertical-align: top;
  float: right;
}

.view_content_bg_item_title > span:nth-child(4) {
  font-size: 28px;
  font-weight: 400;
  color: rgba(23, 203, 188, 1);
  text-align: right;
  vertical-align: top;
  float: right;
}

.view_content_bg_item_buttom {
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 40px;
}
</style>
